<template>
    <div>
        <editor :key="id" v-model="text" :options="options" :initialValue="initialText" :imagePath="imagePath" :imageUpload="imageUpload" :custom_directory="custom_directory" initialEditType="wysiwyg" ref="editor" @change="onEditorChange" @load="onEditorLoad" />

        <q-modal v-model="image_picker" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '50vh'}" @hide="hideImagePickerModal()">
            <q-modal-layout>
                <div>
                    <q-tabs v-model="selectedTab" animated>
                        <q-tab slot="title" name="device" :label="$q.platform.is.desktop ? `${$t('image_from_device')}` : ''" icon="fas fa-tablet-alt" />
                        <q-tab slot="title" name="web" :label="$q.platform.is.desktop ? `${$t('image_from_web')}` : ''" icon="fas fa-globe-americas" />

                        <q-tab-pane name="device" class="q-px-md q-pb-xl q-mt-md">
                            <p>{{ $t('insert_image_from_device') }}</p>
                            <div class="file-picker" @click="imageFilePicker">
                                <q-field type="file" class="q-ma-sm" icon="fas fa-cloud-upload-alt">
                                    <p>{{ $t(image_file_name) }}</p>
                                    <!-- <q-input :icon="'fas fa-cloud-upload-alt'" class="q-my-sm file-picker" v-model="image_file_name" /> -->
                                </q-field>
                            </div>
                            <small><em>{{ $t('accepted_image_file_types') }}</em></small>
                            <q-input class="q-my-sm" v-model="image_file_description" :float-label="$t('image_description')" :placeholder="$t('my_image')" />
                        </q-tab-pane>

                        <q-tab-pane name="web" class="q-px-md q-pb-xl q-mt-md">
                            <p>{{ $t('insert_image_from_web') }}</p>
                            <q-input class="q-my-sm" v-model="web_image_link" :float-label="$t('image_link')" placeholder="http://image.com/image.jpg" />
                            <small><em>{{ $t('web_image_formats') }}</em></small>
                            <q-input class="q-my-sm" v-model="web_image_description" :float-label="$t('image_description')" :placeholder="$t('my_image')" />
                        </q-tab-pane>
                    </q-tabs>
                </div>

            <q-toolbar slot="footer">
                <q-btn class="q-mx-sm" color="positive" :label="$t('insert_image')" @click="insertImage(selectedTab)" />
                <q-btn class="q-mx-sm" color="negative" :label="$t('cancel')" @click="image_picker = false" />
            </q-toolbar>

            </q-modal-layout>
        </q-modal>

    </div>
</template>

<script>
import 'codemirror/lib/codemirror.css'
import '@toast-ui/editor/dist/toastui-editor.css'

import { Editor } from '@toast-ui/vue-editor'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    props: ['editorText', 'id', 'initialText', 'imagePath', 'custom_directory', 'imageUpload'],

    data() {
        return {
            added_custom_button: false,
            image_picker: false,
            selectedTab: 'device',
            web_image_link: '',
            image_file: null,
            image_file_name: 'pick_image_file',
            image_file_description: '',
            web_image_description: '',
            text_with_image_link: '',
            file_url: '',
            cancel_token: '',
            source: '',
            upload_url: process.env.API_URL + '/files/policy/',
            // Editor options
            options: {
                minHeight: '50vh',
                language: 'en_US',
                useCommandShortcut: true,
                useDefaultHTMLSanitizer: true,
                usageStatistics: false,
                hideModeSwitch: true,
                mode: 'wysiwyg',
                toolbarItems: [
                    'heading',
                    'bold',
                    'italic',
                    'strike',
                    'divider',
                    'ul',
                    'ol',
                    'task',
                    'indent',
                    'outdent',
                    'divider',
                    'link',
                ]
            }
        }
    },

    components: {
        'editor': Editor,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        text: {
            get() {
                return this.editorText
            },
            set(val) {
                this.$emit('setMessage', val)
            }
        },
    },

    methods: {
        onEditorChange() {
            this.text = this.$refs.editor.invoke('getMarkdown')

            if (this.imageUpload) {
                if (!this.added_custom_button) {
                    let ui = this.$refs.editor.invoke('getUI')
                    let toolbar = ui.getToolbar()
                    this.$refs.editor.editor.eventManager.addEventType('clickCustomButton')
                    this.$refs.editor.editor.eventManager.listen('clickCustomButton', () => this.openImagePicker())

                    toolbar.insertItem(12, {
                        type: 'button',
                        options: {
                        className: 'fas fa-image',
                        event: 'clickCustomButton',
                        tooltip: 'Insert image',
                        text: '',
                        style: 'color:black;background:none;'
                        }
                    })
                    this.added_custom_button = true

                } else {
                    return
                }
            }

        },

        onEditorLoad () {
            this.added_custom_button = false
        },

        clearImageInputs() {
            setTimeout(() => {
                this.web_image_link = ''
                this.web_image_description = ''
                this.image_file = null
                this.image_file_name = 'pick_image_file'
                this.image_file_description = ''
                this.$refs.editor.editor.focus()
                this.$refs.editor.editor.moveCursorToEnd()
            }, 100)
        },

        openImagePicker() {
            this.image_picker = true
        },

        insertImage(tab) {
            this.image_picker = false

            if (tab === 'web') {
                this.text_with_image_link = this.editorText + `\n![${this.web_image_description}](${this.web_image_link} "${this.web_image_description}")\n`

                this.$emit('setMessageWithImage', this.text_with_image_link)
                this.clearImageInputs()

            } else {

                if (this.image_file) {
                    this.uploadFile(this.image_file)
                } else {
                    this.image_file = null,
                    this.image_file_name = 'pick_image_file'
                    return
                }
            }
        },

        imageFilePicker() {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = '.png, .jpg, .gif'
            let file

            input.onchange = _ => {
                const files = Array.from(input.files)
                file = files[0]

                this.image_file = file
                this.image_file_name = file.name

            }
            input.click()
        },

        uploadFile (file, updateProgress) {

            return new Promise((resolve) => {
                let date = moment()
                let fd = new FormData()
                fd.append('filename', this.image_file_name ? `${this.image_file_name}.${file.name.split('.')[1]}` : file.name)


                if (this.custom_directory) {
                    fd_policy.append('file_directory', this.custom_directory)
                } else {
                    fd.append('file_directory', `${this.imagePath}/${date.year()}/${date.month() + 1}/`)
                }

                this.$q.loading.show()

                this.$axios.post('/api/files/policy/', fd, this.getHeader, { cancelToken: this.source.token })
                .then(response => {
                    // this.startUpload(response.data, file, updateProgress)

                    if (response.data.origin === 'azure') {
                        const blobServiceClient = new BlobServiceClient(
                            `${response.data.base_url}?${response.data.sas_token}`
                        )

                        const main = async () => {
                            const container_client = blobServiceClient.getContainerClient('')

                            const block_blob_client = container_client.getBlockBlobClient(response.data.filename)
                            const upload_blob_response = await block_blob_client.uploadBrowserData(file)

                            let fd_complete = new FormData()
                            fd_complete.append('uploaded', true)
                            fd_complete.append('fileSize', file.size)
                            fd_complete.append('file', response.data.file_id)

                            this.$axios.post('/api/files/complete/', fd_complete, this.getHeader)
                            .then(response => {
                                // this.$refs.uploader.reset()

                                // let item = null
                                // if (this.item) item = this.item
                                // this.$emit('fileUploaded', response.data.fileUrl, item)
                                this.file_url = response.data.fileUrl

                                this.text_with_image_link = this.editorText + `\n![${this.image_file_description}](${this.file_url} "${this.image_file_description}")\n`

                                this.$emit('setMessageWithImage', this.text_with_image_link)
                                this.clearImageInputs()

                            })
                            .finally(() => {
                                resolve()
                                this.$q.loading.hide()
                            })
                        }

                        main()
                    }
                    else {
                        let content_type = file.type != '' ? file.type : 'application/octet-stream'
                        let policy = response.data
                        let file_name = policy.filename
                        let key_path = policy.file_bucket_path

                        let fd_s3 = new FormData()
                        fd_s3.append('key', key_path + file_name)
                        fd_s3.append('acl','private')
                        fd_s3.append('Content-Type', content_type)
                        fd_s3.append("AWSAccessKeyId", policy.key)
                        fd_s3.append('Policy', policy.policy)
                        fd_s3.append('filename', file_name)
                        fd_s3.append('Signature', policy.signature)
                        fd_s3.append('file', file)

                        this.cancel_token = this.$axios.CancelToken
                        this.source = this.cancel_token.source()

                        this.$axios.post(process.env.BUCKET_URL, fd_s3,
                        {
                            // onUploadProgress: function( event ) {
                            //     updateProgress(event.loaded / event.total)
                            // },
                            cancelToken: this.source.token

                        })
                        .then(response => {
                            let fd_complete = new FormData()
                            fd_complete.append('uploaded', true)
                            fd_complete.append('fileSize', file.size)
                            fd_complete.append('file', policy.file_id)

                            this.$axios.post('/api/files/complete/', fd_complete, this.getHeader)
                            .then(response => {
                                // this.$refs.uploader.reset()

                                // let item = null
                                // if (this.item) item = this.item
                                // this.$emit('fileUploaded', response.data.fileUrl, item)
                                this.file_url = response.data.fileUrl

                                this.text_with_image_link = this.editorText + `\n![${this.image_file_description}](${this.file_url} "${this.image_file_description}")\n`

                                this.$emit('setMessageWithImage', this.text_with_image_link)
                                this.clearImageInputs()
                            })
                            .finally(() => {
                                this.$q.loading.hide()
                            })
                        })
                        .finally(() => {
                            resolve()
                        })
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            })
        },

        hideImagePickerModal() {
            this.image_picker = false
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '90vw'
            else return '70vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '50vw'
        },
    },

    beforeDestroy () {
        this.added_custom_button = false
    },
}
</script>

<style lang="stylus" scoped>
.file-picker:hover {
    cursor pointer
}
</style>
